import React from "react"
import type { TextUIPart } from "ai"
import Markdown from "react-markdown"

interface Props {
    readonly part: TextUIPart
}

export default function ChatMessageText({ part }: Props) {
    return <Markdown>{part.text}</Markdown>
}
